import http from './api'

const url = '/pumps'

export const httpGetPumps = (params) => {
  console.log("httpGetPumps called with params:", params);
  console.log("httpGetPumps URL:", `${url}/`);
  
  return http({
    url: `${url}/`,
    method: 'GET',
    params,
  }).then(response => {
    console.log("httpGetPumps success:", response);
    return response;
  }).catch(error => {
    console.error("httpGetPumps error:", error);
    throw error;
  });
}

export const httpGetPump = (id) => {
  console.log("httpGetPump called with id:", id);
  return http({
    url: `${url}/${id}/`,
    method: 'GET',
  })
}

export const httpCreatePump = (data) => {
  console.log("httpCreatePump called with data:", data);
  return http({
    url: `${url}/`,
    method: 'POST',
    data,
  })
}

export const httpUpdatePump = (id, data) => {
  console.log("httpUpdatePump called with id:", id, "data:", data);
  return http({
    url: `${url}/${id}/`,
    method: 'PATCH',
    data,
  })
}

export const httpDeletePump = (id) => {
  console.log("httpDeletePump called with id:", id);
  return http({
    url: `${url}/${id}/`,
    method: 'DELETE',
  })
}

export const httpGetPumpEvents = (pumpId) => {
  console.log("httpGetPumpEvents called with pumpId:", pumpId);
  return http({
    url: `/events/`,
    method: 'GET',
    params: { pump: pumpId, ordering: '-timestamp' },
  });
} 

export const httpGetPumpDetails = (pumpId) => {
  console.log("httpGetPumpDetails called with pumpId:", pumpId);
  return http({
    url: `${url}/${pumpId}/`,
    method: 'GET',
  });
}

export const httpAcknowledgeComment = (eventId) => {
  console.log("httpAcknowledgeComment called with eventId:", eventId);
  return http({
    url: `/events/${eventId}/acknowledge/`,
    method: 'POST',
  });
}

export const httpBulkUpdatePumpStatus = ({ pump_ids, status, comment, timestamp, replaced_parts }) => {
  return http({
    url: `${url}/bulk_update_status/`,
    method: 'POST',
    data: { pump_ids, status, ...(comment != null && { comment }), ...(timestamp != null && { timestamp }), ...(replaced_parts != null && { replaced_parts }) },
  });
} 